import { DialogContentText } from '@mui/material';
import InteractiveAlertDialog from 'components/Dialoges/InteractiveAlertDialog';
import { SHIFT_MANAGEMENT_DIALOG, SHIFT_REFRESH_DIALOG } from 'constants/events';
import CurrencyDialog from 'pages/ShiftManagement/Dialoges/CurrencyDialog';
import { useEffect, useState } from 'react';
import styles from '../../shiftManagement.module.scss';
import { handleLogout } from 'utils/auth';

const ShiftStart = () => {
  const [isCurrencyDialogOpen, setIsCurrencyDialogOpen] = useState<boolean>(false);
  const [isShiftRefreshDialogOpen, setIsShiftRefreshDialogOpen] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener(SHIFT_MANAGEMENT_DIALOG, () => {
      setIsCurrencyDialogOpen(true);
    });
    window.addEventListener(SHIFT_REFRESH_DIALOG, () => {
      setIsShiftRefreshDialogOpen(true);
    });
  }, []);

  return (
    <>
      {isCurrencyDialogOpen ? (
        <CurrencyDialog
          open={isCurrencyDialogOpen}
          shift={'start'}
          onSubmit={() => setIsCurrencyDialogOpen(false)}
        />
      ) : null}
      {isShiftRefreshDialogOpen ? (
        <InteractiveAlertDialog
          open={isShiftRefreshDialogOpen}
          title='Shift not Started'
          Body={() => (
            <DialogContentText className={styles.actionContentBox}>
              No active shift available. Please ask Admin to start shift.
            </DialogContentText>
          )}
          actions={[
            { label: 'Log out', variant: 'outlined', handler: () => handleLogout(false) },
            { label: 'Refresh', size: 'small', handler: () => window.location.reload() },
          ]}
        />
      ) : null}
    </>
  );
};

export default ShiftStart;
